
// export const URL = 'http://localhost:3000' //服务器地址
export const URL = '' //配置真正的服务器地址，使用服务器反向代理来配置的

//设备编号
export const deviceNo = "1122334455667788"

//广播显示弹窗
export const SET_LIGHT_DIALOG_SHOW = 'SET_LIGHT_DIALOG_SHOW'  //schedule亮度--显示
export const SET_LIGHT_DIALOG_HIDE = 'SET_LIGHT_DIALOG_HIDE'  //schedule亮度--隐藏
export const SET_ASSOCIATE_DIALOG_SHOW = 'SET_ASSOCIATE_DIALOG_SHOW'  //schedule关联--显示
export const SET_ASSOCIATE_DIALOG_HIDE = 'SET_ASSOCIATE_DIALOG_HIDE'  //schedule关联--隐藏
export const OUTPUT_PROFILE_DIALOG_SHOW = 'OUTPUT_PROFILE_DIALOG_SHOW'  //导出文件--显示
export const OUTPUT_PROFILE_DIALOG_HIDE = 'OUTPUT_PROFILE_DIALOG_HIDE'  //导出文件--隐藏
export const SPIN_DIALOG_SHOW = 'SPIN_DIALOG_SHOW'  //加载框--显示
export const SPIN_DIALOG_HIDE = 'SPIN_DIALOG_HIDE'  //加载框--隐藏
export const PERMISSION_DIALOG_SHOW = 'PERMISSION_DIALOG_SHOW'  //权限分享框--显示
export const PERMISSION_DIALOG_HIDE = 'PERMISSION_DIALOG_HIDE'  //权限分享框--隐藏
export const Attention_DIALOG_SHOW = 'Attention_DIALOG_SHOW'  //警示弹框--显示
export const Attention_DIALOG_HIDE = 'Attention_DIALOG_HIDE'  //警示弹框--隐藏
export const SET_Emergency_DIALOG_SHOW = 'SET_Emergency_DIALOG_SHOW'  //EmergencySet时间--显示
export const SET_Emergency_DIALOG_HIDE = 'SET_Emergency_DIALOG_HIDE'  //EmergencySet时间--隐藏
export const SET_ControlPageDetailPage_DIALOG_HIDE = 'SET_ControlPageDetailPage_DIALOG_HIDE'  //ControlPageDetailPage_DIALOG_HIDE--隐藏
export const SPIN_DIALOG_Devices_SHOW = 'SPIN_DIALOG_Devices_SHOW'  //加载框--显示
export const SPIN_DIALOG_Devices_HIDE = 'SPIN_DIALOG_Devices_HIDE'  //加载框--隐藏


//area界面-侧边栏
export const AREA_create_build = 'AREA_create_build';
export const AREA_create_area = 'AREA_create_area';
export const AREA_create_group = 'AREA_create_group';
export const AREA_click_group = 'AREA_click_group';
export const AREA_select_build = 'AREA_select_build';
export const AREA_select_area = 'AREA_select_area';
//device界面-Ota
export const DEVICE_type_item = 'DEVICE_type_item';
export const DEVICE_show_layout = 'DEVICE_show_layout';
export const DEVICE_show_ota = 'DEVICE_show_ota';
export const DEVICE_ota_group = 'DEVICE_ota_group';
//schedule界面-侧边栏
export const SCHEDULE_show_detail = 'SCHEDULE_show_detail';
export const SCHEDULE_show_setGroup = 'SCHEDULE_show_setGroup';
//energy界面-侧边栏
export const ENERGY_show_group = 'ENERGY_show_group';
export const ENERGY_show_hot = 'ENERGY_show_hot';
export const ENERGY_Data_Img = 'ENERGY_Data_Img';
export const ENERGY_Data_Log = 'ENERGY_Data_Log';
//布点图相关
export const Group_Map_Click = 'Group_Map_Click';
export const Device_Map_Click = 'Device_Map_Click';
export const Design_Upload_Map = 'Design_Upload_Map';


//屏幕高度
export const webHeight = window.screen.height > document.body.scrollHeight ? window.screen.height : document.body.scrollHeight;


//加密、解密
export const DesKey = 'e3ONK91Sn8nndgeWcHCOkU8c4JSXSulQ';
export const DesIv = '12345678';
export const AesKey = '3a8f1c7d0b9e2a4f6c5d0e1f2a3b4c5d';
export const AesIv = '00000000000000000000000000000000';

//字体
export const Regular = 'MyriadPro-Regular'
export const Light = 'MyriadPro-Light'

//操作
export const Opcode_delete = 0
export const Opcode_edit = 1

//上传
export const Upload_Building = 0
export const Upload_Mesh = 1
export const Upload_Data = 2

//警示弹窗
export const Attention_Scene = "Scene"
export const Attention_Build = "Build"
export const Attention_Area = "Area"
export const Attention_Share = "Share"
